import { memo } from "react";
import BadgeIcon from '@mui/icons-material/Badge';
import { ECommerceOnboarding, ECommerceOnboardingStep } from "consts/ecommerce";
import { StepLabel, type StepLabelProps } from "ui/organizms/ECommerce/Onboarding/common";

const MediaAndComplianceCheckLabel = (props: Partial<StepLabelProps>) => (
    <StepLabel
        to={`${ECommerceOnboardingStep[ECommerceOnboarding.Merchant].MediaAndComplianceCheck}`}
        Icon={BadgeIcon}
        {...props}
    >
        Media & Compliance Check
    </StepLabel>
);

export default memo(MediaAndComplianceCheckLabel);
